import React, { useEffect, useState } from "react";
import { Store, WhatsApp } from "@mui/icons-material";

import WarehouseIcon from "@mui/icons-material/Warehouse";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";

import EmailIcon from "@mui/icons-material/Email";

import calculadora from "../../assets/images/icons/SVG/calculatorIcon.svg";

const SecondaryNav = () => {
  return (
    <>
      <nav id="navs__nav-secondary" className="fixed-bottom">
        <ul
          className="nav_secondary_ul px-3"
        >
          <li className="navs__nav-secondary-disable">
            <a href="/calculadora-losa-con-viguetas">
              <img
                src={calculadora}
                aria-label="Calculadora"
                alt="calculadora"
              />
            </a>
          </li>
          <li>
            <a href="/contacto">
              <EmailIcon aria-label="Contacto" htmlColor="#ffffff" />
            </a>
          </li>
          <li>
            <a href="/donde-comprar">
              <AddBusinessIcon
                aria-label="¿Dónde comprar?"
                htmlColor="#ffffff"
              />
            </a>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default SecondaryNav;
